import { useTranslation } from 'react-i18next';

// Static last-updated marker. Bump on every substantive copy change so the
// printed PDF + the page itself reflect the same revision (LGP-01).
const PRIVACY_LAST_UPDATED = '2026-05-05';

interface Section {
  id: string;
  titleKey: string;
  bodyKey: string;
}

const SECTIONS: ReadonlyArray<Section> = [
  { id: 'quem-somos', titleKey: 'privacy.quem_somos_title', bodyKey: 'privacy.quem_somos_body' },
  { id: 'base-legal', titleKey: 'privacy.base_legal_title', bodyKey: 'privacy.base_legal_body' },
  {
    id: 'dados-tratados',
    titleKey: 'privacy.dados_tratados_title',
    bodyKey: 'privacy.dados_tratados_body',
  },
  {
    id: 'dados-nao-tratados',
    titleKey: 'privacy.dados_nao_tratados_title',
    bodyKey: 'privacy.dados_nao_tratados_body',
  },
  { id: 'direitos', titleKey: 'privacy.direitos_title', bodyKey: 'privacy.direitos_body' },
  {
    id: 'retencao',
    titleKey: 'privacy.retencao_title',
    bodyKey: 'privacy.retencao_body',
  },
  {
    id: 'nao-retaliacao',
    titleKey: 'privacy.nao_retaliacao_title',
    bodyKey: 'privacy.nao_retaliacao_body',
  },
  { id: 'contato-dpo', titleKey: 'privacy.contato_title', bodyKey: 'privacy.contato_body' },
];

export function PrivacidadePage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="fade-in privacy-page">
      <article className="card">
        <h2>{t('privacy.title')}</h2>
        <p style={{ color: 'var(--color-text-secondary)' }}>
          {t('privacy.last_updated', { date: PRIVACY_LAST_UPDATED })}
        </p>

        <nav aria-label={t('privacy.toc_label')} className="privacy-toc">
          <ul>
            {SECTIONS.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`}>{t(s.titleKey)}</a>
              </li>
            ))}
          </ul>
        </nav>

        {SECTIONS.map((s) => (
          <section key={s.id} id={s.id} className="privacy-section">
            <h3>{t(s.titleKey)}</h3>
            <p style={{ whiteSpace: 'pre-line' }}>{t(s.bodyKey)}</p>
          </section>
        ))}
      </article>
    </div>
  );
}
